// extracted by mini-css-extract-plugin
export default {"thread":"Thread_thread__X8wkP","thread__discussion":"Thread_thread__discussion__aToE6","thread__title":"Thread_thread__title__JNnDT"};